import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../../createApiConfig';

export const lmIptvReportsApi = createApi({
  reducerPath: 'lmIptvReportsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['IPTV reports'],
  endpoints: builder => ({
    getIptvReports: builder.query({
      query: (params) => ({
        url: `/links/iptv-technical-reports/`,
        params,
      }),
      providesTags: ['IPTV reports'],
    }),

    createIptvReport: builder.mutation({
      query: (data) => ({
        url: '/links/iptv-technical-reports/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['IPTV reports'],
    }),
    updateIptvReport: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/iptv-technical-reports/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['IPTV reports'],
    }),
    getIptvReportById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/links/iptv-technical-reports/${id}/`,
        params,
      }),
      providesTags: ['IPTV reports']
    }),
  }),
});

export const {
  useGetIptvReportsQuery,
  useLazyGetIptvReportsQuery,
  useCreateIptvReportMutation,
  useUpdateIptvReportMutation,
  useGetIptvReportByIdQuery
} = lmIptvReportsApi;
